import { API_BASE_URL, RECAPTCHA_TOKEN } from "../constants"

export const TCF_URL = {
    //User Module
    USER_LOGIN: `${API_BASE_URL}api/login`,
    USER_LOGOUT: `${API_BASE_URL}api/logout`,
    USER_REGISTRATION: `${API_BASE_URL}api/register`,
    RESEND_VERIFICATION_EMAIL: `${API_BASE_URL}api/resend-email`,
    USER_ACCOUNT_VERIFICATION: (token) => `${API_BASE_URL}api/verify-user/${token}`,
    FORGOT_PASSWORD: `${API_BASE_URL}api/forgot-password`,
    PASSWORD_RESET: `${API_BASE_URL}api/reset-password`,
    VERIFY_PASSWORD_TOKEN: (token) => `${API_BASE_URL}api/verify-password-token/${token}`,
    VALIDATE_TOKEN: `${API_BASE_URL}api/validate-token`,
    CHECK_EMAIL_EXIST: `${API_BASE_URL}api/check-email-exist`,
    GET_USER_DATA: `${API_BASE_URL}api/users/current-user`,
    GET_USER_TOTAL_DONATIONS: (userId) => `${API_BASE_URL}api/get-user-total-donations/${userId}`,
    GET_USER_DONATION_HISTORY: (offset, limit, search_string, sort_by) => `${API_BASE_URL}api/get-user-donations-list/${offset}/${limit}/${search_string}/${sort_by}`,
    GET_USER_RECENT_DONATIONS: (userId, limit) => `${API_BASE_URL}api/get-user-latest-donations/${userId}/${limit}`,
    GET_USER_ACTIVITIES: `${API_BASE_URL}api/users/get-user-activities`,
    GET_USER_GRAPH_DATA: `${API_BASE_URL}api/users/get-graph-data`,
    GET_USER_DETAILS: (userId) => `${API_BASE_URL}api/get-user-details/${userId}`,
    GET_ALL_ACTIVE_USERS: `${API_BASE_URL}api/users-tobe-invited`,
    GET_USER_CURRENCY: `${API_BASE_URL}api/get-user-default-currency`,
    GET_USER_IP: 'https://geolocation-db.com/json/',

    //Profile Module
    CHANGE_PASSWORD: `${API_BASE_URL}api/profile/change-password`,
    UPDATE_USER_DETAILS: `${API_BASE_URL}api/profile/update-user`,
    UPDATE_PROFILE_IMAGE: `${API_BASE_URL}api/profile/update-image`,
    STRIPE_CANCEL_SUBSCRIPTION: `${API_BASE_URL}api/profile/stripe-cancel-subscription`,
    PAYPAL_CANCEL_SUBSCRIPTION: `${API_BASE_URL}api/profile/paypal-cancel-subscription`,

    //Countries Module
    GET_CITIES_BY_COUNTRY_ID: (countryId) => `${API_BASE_URL}api/cities/${countryId}`,
    GET_COUNTRY_STATES: (countryId) => `${API_BASE_URL}api/states/${countryId}`,
    COUNTRY_ALLOWED_FOR_CHEQUE: (donorCountry, currencyCountry) => `${API_BASE_URL}api/check-allowed-country/${donorCountry}/${currencyCountry}`,
    GIFT_AID_COUNTRY_CHECK: `${API_BASE_URL}api/check-if-country-has-giftaid`,
    CORPORATE_MATCH_COUNTRY_CHECK: `${API_BASE_URL}api/is-country-corporate-match`,
    IS_COUNTRY_ACTIVE_FOR_FUNDRAISER: (countryId) => `${API_BASE_URL}api/check-if-country-partner-isactive-for-fundraiser/${countryId}`,
    IS_COUNTRY_ACTIVE_FOR_DONOR: (countryId) => `${API_BASE_URL}api/check-if-country-partner-isactive-for-donor/${countryId}`,
    GET_BANKS_LIST: `${API_BASE_URL}api/get-banks-list`,
    GET_CURRENCY_AMOUNT_CHOICES: `${API_BASE_URL}api/get-currency-default-amounts`,
    GET_ALL_CURRENCIES: `${API_BASE_URL}api/currencies`,
    GET_ALL_COUTRIES: `${API_BASE_URL}api/countries`,
    COUNTRIES_WITHOUT_PARTNERS: `${API_BASE_URL}api/countries-without-partners`,
    COUNTRIES_WITH_CURRENCIES: `${API_BASE_URL}api/countries-with-currencies`,
    TAX_DONATION_MESSAGES: (countryId) => `${API_BASE_URL}/api/tax-donation-messages/${countryId}`,

    //Donations Module
    CALCULATE_PRODUCT_IMPACT: `${API_BASE_URL}api/calculate-product-impact`,
    GET_STRIPE_PAYMENT_INTENT: (campaignPage) => `${API_BASE_URL}api/stripe/stripe-payment-intent/${campaignPage}`,
    ACH_PAYMENT_INTENT: `${API_BASE_URL}api/create-stripe-ach-intent`,
    STRPE_CHECKOUT: (campaignPage) => `${API_BASE_URL}api/checkout-payment/stripe/${campaignPage}`,
    PAYPAL_CHECKOUT: (campaignPage) => `${API_BASE_URL}api/checkout-payment/paypal/${campaignPage}`,
    HBL_CHECKOUT: `${API_BASE_URL}api/get-hbl-config`,
    BANK_TRANSFER: (campaignPage) => `${API_BASE_URL}api/checkout-payment/bank-transfer/${campaignPage}`,
    UPLOAD_RECEIPT: `${API_BASE_URL}api/upload-receipt`,
    CHEQUE_DEPOSITE: (campaignPage) => `${API_BASE_URL}api/checkout-payment/cheque-deposit/${campaignPage}`,
    GET_PAYMENT_METHODS: `${API_BASE_URL}api/get-payment-methods`,
    GET_DONATION_DETAILS: (transactionId) => `${API_BASE_URL}api/get-donation-details/${transactionId}`,
    GET_CAPTURE_CONTEXT: `${API_BASE_URL}api/v2/hbl/capture-context`,
    VERIFY_UC_PAYMENT: `${API_BASE_URL}api/v2/hbl/check-transaction`,

    //Fundraiser/Campaign Module
    GET_ALL_FUNDRAISER_PAGES: `${API_BASE_URL}api/fundraiser-pages-all`,
    GET_FUNDRAISER_DETAILS: (slug) => `${API_BASE_URL}api/fundraiser-pages/${slug}`,
    GET_EVENT_ID: `${API_BASE_URL}api/get-event-id`,
    GET_COUNTRY_GOAL_RANGE: (countryId) => `${API_BASE_URL}api/get-minmax-goalrange/${countryId}`,
    CREATE_FUNDRAISER_PAGE: `${API_BASE_URL}api/fundraiser-pages`,
    UPDATE_FUNDRAISER_PAGE: (pageId) => `${API_BASE_URL}api/fundraiser-pages/${pageId}`,
    GET_ALL_CAMPAIGNS: (countryId) => `${API_BASE_URL}api/campaigns?country_id=${countryId}`,
    GET_OCCASIONS: `${API_BASE_URL}api/occasions`,
    GET_DEFAULT_IMAGE: `${API_BASE_URL}api/get-fundraiser-page-default-images`,
    CREATE_TEAM_MEMBER: `${API_BASE_URL}api/create-team-member`,
    REMOVE_TEAM_MEMBER: `${API_BASE_URL}api/remove-team-member`,
    GET_TEAM_MEMBERS: (id) => `${API_BASE_URL}api/fr-team-members/${id}`,
    GET_TEAM_MEMBERS_WITH_PAGINATION: (id, status, limit, pageNo) => `${API_BASE_URL}api/fr-team-members-pagination/${id}/${status}/${limit}?page=${pageNo}`,
    TEAM_MEMBERS_COUNT: (id, status) => `${API_BASE_URL}api/fr-team-members-count/${id}/${status}`,
    TEAM_MEMBER_DETAILS: (id, pageId) => `${API_BASE_URL}api/fr-single-member/${id}/${pageId}`,
    PAGE_DONORS: (id, limit, pageNo) => `${API_BASE_URL}api/fr-donors/${id}/${limit}?page=${pageNo}`,
    PAGE_RECENT_DONATIONS: (id, limit, offset) => `${API_BASE_URL}api/fr-donors-mostrecent/${id}/${limit}/${offset}`,
    PAGE_HIGHEST_DONATIONS: (id, limit, offset) => `${API_BASE_URL}api/fr-donors-mostdonations/${id}/${limit}/${offset}`,
    DONATIONS_COUNT: (id) => `${API_BASE_URL}api/fr-donors-count/${id}`,
    FUNDRAISERS_COUNT: `${API_BASE_URL}api/fundraiser-pages-list-counts`,
    VALIDATE_PAGE_TITLE: `${API_BASE_URL}api/verify-fundraiser-page-title`,
    FUNDRAISERS_BY_USER: `${API_BASE_URL}api/list-fr-pages-by-user`,
    ADD_UPDATES_ON_FUNDRAISER: `${API_BASE_URL}api/add-updates-as-desc-images`,
    ADD_SOCIAL_COUNT: `${API_BASE_URL}api/add-social-count`,
    GET_SOCIAL_COUNT: (id) => `${API_BASE_URL}api/get-social-count/${id}`,
    GET_FUNDRAISER_UPDATES: (pageId, offset, limit) => `${API_BASE_URL}api/get-fundraiser-page-updates/${pageId}/${offset}/${limit}`,
    GET_FUNDRASERS_BY_CAMPAIGN: (eventId, limit, offset) => `${API_BASE_URL}api/fundraisers-by-campaign/${eventId}/${limit}/${offset}`,
    GET_CAMPAIGN_DETAILS: (eventId) => `${API_BASE_URL}api/campaign-by-event/${eventId}`,
    SEND_THANKS_TO_DONOR: `${API_BASE_URL}api/send-thankyou-message`,
    INVITE_NEW_USER: `${API_BASE_URL}api/invite-new-user`,
    GOOD_LUCK_MESSAGES: `${API_BASE_URL}/api/fundraiser-goodluck-messages`,
    GET_PRODUCTS: (countryId) => `${API_BASE_URL}api/products?country_id=${countryId}`,
}

export const WEB_URL = {
    HOME: "/",
    LOGIN: "/login",
    EVENTS: "/events",
    EVENT_DETAILS: "/events/details",
    PAGE_NOT_FOUND: "/not-found",
    COOKIE_POLICY: "/cookie-policy",
    FUNDRAISER_LISTING: "/fundraisers",
    PRIVACY_POLICY: "/privacy-policy",
    FORGOT_PASSWORD: "/forgot-password",
    FAQS: "/FAQs",
    ABOUT_US: "/about-us",
    DONATION_FAILED: "/transaction-failed/:donationId",
    CREATE_FUNDRAISER: "/create-fundraiser",

    PASSWORD_RESET: (token) => token ? `/password-reset/${token}` : "/password-reset/:token",
    PROFILE: (tab) => tab ? `/profile?tab=${tab}` : "/profile",
    CAMPAIGN_DETAILS: (eventId) => eventId ? `/campaign/${eventId}` : "/campaign/:eventId",
    FUNDRAISER_CHECKOUT: (pageId) => pageId ? `/checkout/${pageId}` : "/checkout/:pageId",
    CAMPAIGN_CHECKOUT: (eventId) => eventId ? `/campaign-checkout/${eventId}` : "/campaign-checkout/:eventId",
    THANK_YOU: (trasanctionNumber) => trasanctionNumber ? `/thankyou/${trasanctionNumber}` : "/thankyou/:trasanctionNumber",
    FUNDRAISER_DETAILS: (pageId, pageName) => pageId && pageName ? `/fundraiser/${pageId}/${pageName}` : "/fundraiser/:pageId/:pageName" ,
    FUNDRAISER_DETAILS_BY_ID: (pageId) => pageId ? `/fundraiser/${pageId}` : "/fundraiser/:pageId",
    UPDATE_FUNDRAISER: (pageId, pageName) => pageId && pageName ? `/edit-fundraiser/${pageId}/${pageName}` : "/edit-fundraiser/:pageId/:pageName",
}

export const RECAPTCHA_SCRIPT_URL = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_TOKEN}`;